export { default } from "./useTeacherLanguageGet";
